import React from "react";
import StickyBox from "react-sticky-box";
import styles from "../assets/css/lastNews.module.scss";
import {Container, Grid, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import configs from '../utils/config.json';
import {useDataState} from "../context/DataContext";
import {Global} from "@emotion/react";

const LastNews = (props) => {
    const data=useDataState();


    return <div className={styles.container}>

        <Container maxWidth={"lg"}>
            <div className={styles.componentTitleContainer}>
                <Typography variant={"h6"}>{props.title}</Typography>
                {/*<Typography variant={"body2"}>آخرین احبار برای شما</Typography>*/}
            </div>
            <Grid container>
                <Grid item md={8} xs={12}>

                    {props.content.length>0?<div style={{padding: 15}}>
                        <StickyBox offsetTop={10} offsetBottom={10}>
                            <div className={styles.mainNewsContainer}>
                                <Link to={`/blog/${props.content[0].id}`}>
                                    <img src={`${configs.server.Storage}/${props.content[0].img}`} alt={""}/>
                                    <Typography variant={"h6"} className={styles.title}>
                                        {props.content[0].title}
                                    </Typography>
                                    <Typography variant={"body1"}
                                                className={styles.description}>{props.content[0].des}
                                    </Typography>
                                </Link>
                            </div>

                        </StickyBox>
                    </div>:<></>}


                </Grid>
                <Grid item md={4} xs={12}>
                    <div style={{padding: 15}}>
                        {props.content.slice(1).map((item, index) => <Item {...item} key={index}/>)}

                    </div>
                </Grid>
            </Grid>

        </Container>

    </div>;
};


const Item = (props) => {
    return <div className={styles.itemContainer}>
        <Link to={`/blog/${props.id}`}>
            <Typography className={styles.date} variant={"caption"} component={"span"}>{props.description}</Typography>
            <Typography className={styles.title} variant={"body1"} component={"p"}>{props.title}</Typography>
        </Link>

    </div>
}
export default LastNews;